@if (shouldHideLogin) {
  <div class="login-exit-overlay" aria-busy="true" aria-live="polite" aria-label="Signing in">
    <div class="login-exit-loader">
      <img src="assets/images/login/workluge-logo.png" class="login-exit-logo" alt="WorkLuge Logo" />
      <app-spinner [size]="32"></app-spinner>
    </div>
  </div>
}

@if (!shouldHideLogin) {
@defer {
<app-festival-decoration></app-festival-decoration>
<div class="login_page" [class.fall-of-summer]="fallOfSummer" [class.thanksgiving]="thanksgiving" [class.halloween]="halloween" [class.remembrance]="remembrance" [class.festival-active]="hideLoginIllustrations">
  @if (!hideLoginIllustrations) {
  <div class="illustration left" [class]="'entry-' + entryPoint()">
    <img src="assets/images/login/all-sd.png" alt="Shade Illustration" />
    <img src="assets/images/login/cycl.png" alt="Bike Illustration" />
    <img src="assets/images/login/road.png" alt="Road Illustration" />
  </div>
  }

  <div class="login_card">
    <img src="assets/images/login/techwyse-logo.png" class="logo" alt="TechWyse Logo" />
    @if (remembrance) {
    <img src="assets/images/events/rem-poppy.png" class="remembrance-poppy" alt="" draggable="false" />
    }

    <div class="quote quote--stacked">
      <img src="assets/images/otp.gif" class="otp-gif" alt="OTP verification" />
      <div class="quote-copy">
        <h1 class="quote-title">{{ stepTitle() }}</h1>
        <p class="quote-message">{{ stepMessage() }}</p>
      </div>
    </div>

    @if (!showOtpField()) {
    <form [formGroup]="contactForm" (ngSubmit)="sendOtp()">
      <div class="input_group">
        <div class="form-fields"
          [class]="email?.valid && email?.touched && !errorMessage() ? 'input-with-success' : showEmailFieldError() ? 'input-with-error' : ''">
          <input
            type="text"
            id="email"
            formControlName="email"
            placeholder="Email or Phone"
            autocapitalize="off"
            autocomplete="off"
            autocorrect="off"
            spellcheck="false"
            [class.is-invalid]="showEmailFieldError()"
            [class.is-valid]="email?.valid && email?.touched"
            (input)="onEmailInput($event)"
            (focus)="onEmailFocus()"
            (blur)="onEmailBlur()" />
          @if (email?.valid && email?.touched && !errorMessage()) {
          <span class="success-circle"></span>
          }
          @if (showEmailFieldError()) {
          <span class="error-circle"></span>
          }
        </div>
      </div>
      <div class="error_wrap">
        @if (showEmailFieldError() && getErrorMessage('email', contactForm)) {
        <div class="error_message">
          {{ getErrorMessage('email', contactForm) }}
        </div>
        }
      </div>

      <div class="btn_wrap">
        <a routerLink="/login" class="back-link">Back to Login</a>
        <app-auth-festive-decoration page="forgot"></app-auth-festive-decoration>
        <button type="submit" [disabled]="contactForm.invalid || isLoading()">
          @if (!isLoading()) {
          <span>Send OTP</span>
          } @else {
          <app-spinner [size]="16"></app-spinner>
          }
        </button>
      </div>
    </form>
    }

    @if (showOtpField()) {
    <form [formGroup]="otpForm" (ngSubmit)="loginWithOtp()">
      <p class="step-helper-text">Type the 4-digit code from your message.</p>
      <div class="input_group">
        <div class="form-fields">
          <div class="otp-input-container">
            @for (i of otpIndexes; track i) {
            <input
              type="text"
              inputmode="numeric"
              [formControlName]="'otp' + (i + 1)"
              class="otp-input"
              [class.is-invalid]="otpForm.get('otp' + (i + 1))?.errors?.['backendError']"
              maxlength="1"
              (input)="onOtpInput($event, i)"
              (keydown)="onKeyDown($event, i)"
              (paste)="onOtpPaste($event)" />
            }
          </div>
          @if (otpForm.invalid && otpForm.touched && !errorMessage()) {
          <div class="validation_error">
            Please enter all 4 digits
          </div>
          }
        </div>
      </div>
      <div class="error_wrap">
        @if (errorMessage() && otpForm.get('otp1')?.errors?.['backendError']) {
        <div class="error_message">
          {{ errorMessage() }}
        </div>
        }
      </div>
      <div class="btn_wrap">
        <button type="button" class="change-contact-btn" (click)="changeContact()">Back</button>
        <button type="submit" [disabled]="otpForm.invalid || isLoading()">
          @if (!isLoading()) {
          <span>Login</span>
          } @else {
          <app-spinner [size]="16"></app-spinner>
          }
        </button>
      </div>
      <div class="secondary_actions">
        <a routerLink="/login" class="back-link">Back to Login</a>
      </div>
    </form>
    }

    <img src="assets/images/login/workluge-logo.png" class="footer_logo" alt="WorkLuge Logo" />
  </div>

  @if (remembrance) {
  <div class="remembrance-bees" aria-hidden="true">
    @for (bee of loginHoneybees; track $index) {
    <img
      class="remembrance-bee"
      [class.remembrance-bee--right]="bee.path === 'right'"
      [class.remembrance-bee--left]="bee.path === 'left'"
      src="assets/images/events/honeybee.gif"
      alt=""
      draggable="false"
      loading="lazy"
      decoding="async"
      [style.--bee-left]="bee.left"
      [style.--bee-top]="bee.top"
      [style.--bee-size]="bee.size"
      [style.--bee-duration]="bee.duration"
      [style.--bee-delay]="bee.delay"
    />
    }
  </div>
  }

  @if (!hideLoginIllustrations) {
  <div class="illustration right">
    <img src="assets/images/login/str-grp.png" alt="Star Illustration" />
    <img src="assets/images/login/moon.png" alt="Moon Illustration" />
  </div>
  }
</div>
<footer
  [class.fall-of-summer]="fallOfSummer"
  [class.thanksgiving]="thanksgiving"
  [class.halloween]="halloween"
  [class.remembrance]="remembrance"
>© 2000–{{ currentYear }} Licenced Copyright by TechWyse. All rights reserved.</footer>
}
}
